import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from "./core/components/header/header.component";
import { FooterComponent } from "./core/components/footer/footer.component";

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, FooterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'customer-portal';

  constructor() {
    // Only set language if not already set (e.g., not logged in)
    if (!window.localStorage.getItem('language')) {
      const browserLang = window.navigator.language;
      // Use 'fr' for any French variant, else default to 'en'
      const lang = browserLang && browserLang.toLowerCase().startsWith('fr') ? 'fr' : 'en';
      window.localStorage.setItem('language', lang);
    }
  }
}
